export default __webpack_public_path__ + "static/media/black-parking-clock.c9a5e76d.png";